/***
 * 创建人：李珊
 * 时间：2020-02-06
 * 描述: 查看素材详情-新增或编辑素材目录
 * 使用说明:
 * 更新说明:
 */
import { Component, OnInit, ViewChild, Output, Input, EventEmitter } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { KmsService } from '../../../../kms.service';
import { environment } from 'src/environments/environment';
import { SelectImgsComponent } from '../select-imgs/select-imgs.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
@Component({
  selector: 'app-catalogue-addorupdate',
  templateUrl: './catalogue-addorupdate.component.html',
  styleUrls: ['./catalogue-addorupdate.component.css']
})
export class CatalogueAddorupdateComponent implements OnInit {
  //弹出层组件
  @ViewChild('modal') modal: SwModalframeComponent; 
  //输入参数
  @Input() param: any;  
  //抛出事件
  @Output() callback = new EventEmitter(); 
  //标题
  headerLoGo:string;   
  formModel:any = {details:[]};  
  originImgs:any = []; 
  //保存按钮是否可点击
  clickEnable = true;
  //父级目录选项
  catalogueTree:any = [];
  //禁止选中的父级节点
  readonlySelfIds:any = [];
  constructor(
    private kmsService: KmsService,
    private create: SwCreateModalComponentService,
    private box:SwMassageBoxService
  ) { 

  }

  ngOnInit() {
    // 查询目录详情
    this.clickLoca(this.param);
    // 查询目录树信息
    this.getCatalog();
  }

  clickLoca(params: any){
    this.formModel.menuId = params.menuId;
    this.formModel.materialId = params.materialId;
    let upOrAddStr;
    //当前操作为编辑时
    if(params.upOrAdd == "Edit"){
      upOrAddStr = '编辑';
      this.headerLoGo = upOrAddStr + '目录';
      this.getDetailById();
      this.readonlySelfIds = [params.menuId];
    }else{//当前操作为新增时
      upOrAddStr = '新增';
      this.headerLoGo = upOrAddStr + '目录';
      this.formModel.parentId = params.parentId;
    }
  }

  // 根据主键id查询目录信息
  getDetailById() {
    this.kmsService.queryMaterialMenuById(this.formModel.menuId).subscribe(
      data => {
        if (data.code == 200) {
          this.formModel = data.data;
          if(this.formModel.details.length>0){
            this.formModel.details = this.formModel.details.sort(function (a, b) { return a.pagesNum - b.pagesNum });
            this.formModel.details.forEach(element => {
              element['src'] = environment.staticFileUrl + this.getThumbnailImg(element.filePath);
            });
            this.originImgs = JSON.parse(JSON.stringify(this.formModel.details));
          }
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 选择图像
  selectImg(){
    const data = {
      materialId: this.param.materialId,
      imgs: this.formModel.details
    };
    this.create.createModal(SelectImgsComponent, data, this.selectImgCallback.bind(this));
  }

  selectImgCallback(event){
    this.formModel.details = event;
  }

  // 删除图像
  delete(i){
    this.formModel.details.splice(i,1);
  }

  // 查询目录
  getCatalog(){
    this.kmsService.queryMaterialMenuList(this.param.materialId).subscribe(
      data => {
        let res = data.data;
        if(res){
          // 按照起始页码升序排列
          res = res.sort(function (a, b) { return a.startPage - b.startPage });
          res.forEach(element => {
            element['pid'] = element['parentId'];
            element['id'] = element['menuId'];
            element['text'] = element['menuName'];
          });
          this.catalogueTree = res;
        }else{
          this.catalogueTree = [];
        }
      }
    );
  }

  //表单提交
  onSubmit({ value, valid }, event: Event) {
    this.clickEnable = false;
    // 保存目录信息
    this.formModel.parentId = this.formModel.parentId ? this.formModel.parentId : 'root';
    let addIds = [], deleteIds = [];
    if(this.param.upOrAdd == 'Add'){
      addIds = this.formModel.details.map(el => el.detailId);
      deleteIds = [];
    }else{
      this.originImgs.forEach(el => {
        if(this.formModel.details.filter(el1 => el1.detailId == el.detailId).length == 0){
          deleteIds.push(el.detailId);
        }
      });
      this.formModel.details.forEach(el => {
        if(this.originImgs.filter(el1 => el1.detailId == el.detailId).length == 0){
          addIds.push(el.detailId);
        }
      });
    }
    let params = JSON.parse(JSON.stringify(this.formModel));
    params['detailIds'] = addIds;
    params['deleteIds'] = deleteIds;
    params['startPage'] = params.details[0].pagesNum;
    params['endPage'] = params.details[params.details.length - 1].pagesNum;
    delete params.details;
    this.kmsService.saveOrUpdateMaterialMenu(params).subscribe(data => {
      this.clickEnable = true;
      if (data['code'] == 200) {
        this.box.success('保存成功!');
        // 关闭框
        this.modal.toggle();
        // 回调
        this.callback.emit(true);
      } else {
        this.box.danger('保存失败!');
      }
    });
  }

  // 根据素材每页原图获取缩略图
  getThumbnailImg(path){
    if(path){
        let arr = path.split('/');
        let str = '';
        for(let i=0;i<arr.length;i++){
            if(i == arr.length - 1){
                let arr1 = arr[i].split('.');
                str += ('THUMB/'+arr1[0]+'_300@x.'+arr1[1]);
            }else{
                str += arr[i]+'/';
            }
        }
        return str;
    }else{
        return '';
    }
  }
}


